import React from "react";
import LegalShell, { LegalSection } from "../components/ui/LegalShell";

const Bullets = ({ items }) => (
  <ul className="space-y-2">
    {items.map((item, i) => (
      <li key={i} className="flex gap-2.5">
        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-gold" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

const infoCards = [
  { icon: "🛡️", title: "Security", color: "#efbf04", text: "We use standard security measures to protect your data." },
  { icon: "✉️", title: "Contact", color: "#21cbf3", text: "info@gamegoblin.eu" },
  { icon: "📈", title: "Analytics", color: "#9701fb", text: "We may use analytics providers to understand and improve the service." },
];

const toc = [
  { id: "collect", label: "What we collect" },
  { id: "use", label: "How we use it" },
  { id: "legal", label: "Legal basis" },
  { id: "protect", label: "Storage & protection" },
  { id: "rights", label: "Your rights" },
];

export default function PrivacyPage() {
  return (
    <LegalShell
      icon="🔐"
      title="Privacy Policy"
      updated="October 16, 2025"
      intro={`Game Goblin ("we", "our", "us") is committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you use our website and services.`}
      toc={toc}
      infoCards={infoCards}
    >
      <LegalSection id="collect" title="Information We Collect">
        <Bullets
          items={[
            "Email address – if you sign up for our newsletter or create an account.",
            "Interaction data – including games you like, favorite, or interact with on our website.",
            "Technical data – such as IP address, browser type, and basic usage information (collected automatically through analytics tools).",
          ]}
        />
      </LegalSection>

      <LegalSection id="use" title="How We Use Your Data">
        <Bullets
          items={[
            "Provide and improve our recommendation features and user experience.",
            "Send you updates, newsletters, or game recommendations if you have opted in.",
            "Analyze general usage to understand how our service is used and make improvements.",
          ]}
        />
        <p className="text-white/90 font-medium mt-3">
          We do not sell or rent your data to third parties.
        </p>
      </LegalSection>

      <LegalSection id="legal" title="Legal Basis for Processing">
        <Bullets
          items={[
            "Your consent – when you sign up with your email or choose to receive recommendations.",
            "Legitimate interest – to improve our services and provide relevant game suggestions.",
          ]}
        />
      </LegalSection>

      <LegalSection id="protect" title="How We Store and Protect Your Data">
        <Bullets
          items={[
            "Your data is stored securely in our databases.",
            "We take appropriate technical and organizational measures to protect personal data against unauthorized access, loss, or misuse.",
            "We only keep your personal data for as long as it is necessary for the purposes outlined in this policy.",
          ]}
        />
      </LegalSection>

      <LegalSection id="rights" title="Your Data Protection Rights">
        <Bullets
          items={[
            "The right to access the personal data we hold about you.",
            "The right to request correction of inaccurate or incomplete data.",
            "The right to request erasure of your personal data (“right to be forgotten”).",
            "The right to restrict processing of your personal data.",
            "The right to object to processing of your personal data.",
            "The right to data portability.",
          ]}
        />
        <p className="mt-3">
          You can exercise these rights by contacting us at{" "}
          <a
            href="mailto:info@gamegoblin.eu"
            className="text-brand-gold font-semibold hover:underline"
          >
            info@gamegoblin.eu
          </a>
          .
        </p>
      </LegalSection>
    </LegalShell>
  );
}
